import { ASSETS_BASE_URL } from "../config";

// themeColors.js
export const themeColors = {
	blue: {
		light: "#3AABE4",
		main: "#1D99D6",
		dark: "#146690",
		contrastText: "#fff",
	},
	red: {
		light: "#FFCDD2",
		main: "#F44336",
		dark: "#D32F2F",
		contrastText: "#fff",
	},
	orange: {
		light: "#FFE0B2",
		main: "#FF9800",
		dark: "#F57C00",
		contrastText: "#fff",
	},
	cyan: {
		light: "#B2EBF2",
		main: "#00BCD4",
		dark: "#0097A7",
		contrastText: "#fff",
	},
};


export const fonts = {
	Poppins: "'Poppins', sans-serif",
	Inter: "'Inter', sans-serif",
	Roboto: "'Roboto', sans-serif",
	Montserrat: "'Montserrat', sans-serif",
	Lato: "'Lato', sans-serif",
	"Open Sans": "'Open Sans', sans-serif",
	Rift: "'Rift', sans-serif",
	Merriweather: "'Merriweather', serif",
};

export const AuthPageStyles = {
	backgroundImage: `
			linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
			url('${ASSETS_BASE_URL}/home_bg2.jpg')
		`,
	backgroundSize: "cover",
	backgroundPosition: "center",
};

// Deployment-specific Site Services configuration.
// Update this array per environment to control which switches appear in Manage Sites form.
export const siteServiceOptions = [
	{ key: "service_level_agreement", label: "LABELS.SERVICE_LEVEL_AGREEMENT" },
	{ key: "maintenance_partnership_program", label: "LABELS.MAINTENANCE_PARTNERSHIP_PROGRAM" },
	{ key: "amfmethod_premium", label: "LABELS.AMFMETHOD_PREMIUM", href: "https://www.amfmethodpremium.com" },
	{ key: "sustainable_oven_service", label: "LABELS.SUSTAINABLE_OVEN_SERVICE" },
	{ key: "machine_dashboard_ixon", label: "LABELS.MACHINE_DASHBOARD_IXON" },
	{ key: "predictive_maintenance", label: "LABELS.PREDICTIVE_MAINTENANCE" },
];
